import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../utils/lib/utils';
import { Text } from './text';

const PageHeader = React.forwardRef(({ 
  title, 
  description, 
  className,
  ...props 
}, ref) => {
  return (
    <div
      ref={ref}
      className={cn('space-y-2', className)}
      {...props}
    >
      <Text variant="h1" className="text-2xl font-bold tracking-tight">
        {title}
      </Text>
      {description && (
        <Text variant="body" className="text-muted-foreground">
          {description}
        </Text>
      )}
    </div>
  );
});

PageHeader.displayName = 'PageHeader';

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  className: PropTypes.string,
};

export { PageHeader }; 